import { Injectable } from '@angular/core';
import { FamilyModel, PaginationModel, RequestParamModel } from "@coreModels";
import { ApiConstants } from "@coreConstant";
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FamilyService {

  constructor(private http: HttpClient) { }

  /**
   *  Get all family list
   * @param requestParamModel
   * @returns
   */
  getFamilies(requestParamModel?: RequestParamModel) {
    return this.http.get(`${ApiConstants.FAMILY_LIST_URL}${requestParamModel?.getParams()}`, { observe: 'response' })
      .pipe(map((response: any) => {
        const familyList = new PaginationModel<FamilyModel>();
        const headers = response.headers;
        familyList.setHeaders(headers);
        familyList.data = response.body.data as FamilyModel[]; // Make sure this line reflects the correct data structure
        return familyList;
      }), catchError((err: unknown) => {
        return throwError(() => err);
      }));
  }
}
